var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63906 15.2871C9.08766 12.0607 10.5155 8.60745 10.3927 5.99014C10.3294 4.64073 9.85709 3.53043 9.06418 2.7616C8.27631 1.99765 7.13106 1.5307 5.63044 1.5307C4.13026 1.5307 3.01099 1.99713 2.25277 2.75621C1.48829 3.52154 1.04568 4.63015 1.00334 5.98339C0.921275 8.60649 2.3542 12.0615 5.63906 15.2871ZM1.52015 2.12313C2.49337 1.14882 3.89258 0.600586 5.63044 0.600586C7.36786 0.600586 8.78606 1.1483 9.78585 2.11774C10.7806 3.0823 11.3202 4.42411 11.3918 5.94958C11.5346 8.99389 9.82656 12.8361 5.97719 16.2825L5.62187 16.6006L5.27501 16.2745C1.61032 12.8294 -0.0912236 8.99247 0.00376359 5.95634C0.0513691 4.43469 0.553185 3.09118 1.52015 2.12313Z",
    fill: "#525559"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70002 7.89785C6.69414 7.89785 7.50002 7.09196 7.50002 6.09785C7.50002 5.10374 6.69414 4.29785 5.70002 4.29785C4.70591 4.29785 3.90002 5.10374 3.90002 6.09785C3.90002 7.09196 4.70591 7.89785 5.70002 7.89785ZM5.70002 8.89785C7.24642 8.89785 8.50002 7.64425 8.50002 6.09785C8.50002 4.55145 7.24642 3.29785 5.70002 3.29785C4.15363 3.29785 2.90002 4.55145 2.90002 6.09785C2.90002 7.64425 4.15363 8.89785 5.70002 8.89785Z",
    fill: "#525559"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdress);
export default __webpack_public_path__ + "static/media/adress.6f88e16fa2ab090b866af782e5ecdaf9.svg";
export { ForwardRef as ReactComponent };